import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { BonificoOrderDTO } from "./BonificoOrderDTO.ts";

export function useUpdateBonificoOrderInvoiceItemDescription() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const updateInvoiceItemDescription = async (
    orderId: string,
    invoiceItemDescription: string,
  ): Promise<BonificoOrderDTO> => {
    setLoading(true);
    try {
      const { data } = await createAxiosInstance().put<BonificoOrderDTO>(
        `/bonifico-orders/${orderId}/invoice-item-description`,
        { invoiceItemDescription },
      );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return { updateInvoiceItemDescription, loading };
}
